import React from "react";
import { Fragment, useRef } from "react";
import { createPortal } from "react-dom";
import { Dialog, Transition } from "@headlessui/react";
import PropTypes from "prop-types";

/**
 * Renders into document.body so fixed positioning stacks above Ant Design modals
 * (antd modal content often uses transform, which traps descendant fixed layers).
 */
const Modal = (props) => {
  const cancelButtonRef = useRef(null);

  const modalTree = (
    <Transition.Root show={props.open} as={Fragment}>
      <Dialog
        as="div"
        static={props?.maskClosable !== false}
        className={`headless-app-modal fixed inset-0 z-[3000] center-modal-lg ${
          props.showScroll === true ? "" : "overflow-y-auto"
        }`}
        initialFocus={cancelButtonRef}
        open={props.open}
        onClose={(value) => {
          if (props?.maskClosable === false) return;
          props.onClose?.(value);
        }}
      >
        <div
          className={`min-h-scrn px-4 center-modal-content flex justify-center ${
            props.scroll === true ? "h-screen" : ""
          }`}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 theme-backdrop-modal transition-opacity" />
          </Transition.Child>

          <span
            className="inline-block h-scrn align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div
              ref={cancelButtonRef}
              className={`inline-block align-bottom bg-white overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-top sm:${
                props.modalWidth
              } 
              ${
                props?.responsiveClass
                  ? props?.responsiveClass
                  : "w-full lg:w-3/4 xl:w-2/3 2xl:w-1/2"
              }
         
              
              ${props.scroll === true ? "overflow-y-scroll" : ""}`}
            >
              {props.children}

              <button
                style={{
                  display: "none",
                }}
                className="rounded-md bg-gray-700 px-4 py-2 font-semibold text-white"
                ref={cancelButtonRef}
                onClick={props.onClose}
              >
                CANCEL
              </button>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );

  if (typeof document === "undefined") {
    return null;
  }

  return createPortal(modalTree, document.body);
};

Modal.propTypes = {
  children: PropTypes.node,
  modalWidth: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default Modal;
